import MarketingControlledButton from '@hellodarwin/app-core/lib/components/marketing-controlled-buttons';
import AppHeader from '@hellodarwin/app-core/lib/layouts/app-layout/components/AppHeader';
import { usePremiumAccess } from '@hellodarwin/app-core/lib/providers';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../app/index';
import TourChecklistDropdown from '../components/dashboard/tour-checklist-block/tour-checklist-dropdown';
import { useClientAnalytics } from '../features/analytics/use-client-analytics';
import { selectCompanyAdmin } from '../features/api/slices/global-slice';
import {
  fetchLegalStructures,
  selectLegalStructures,
} from '../features/api/slices/grants-slice';
import {
  selectCompany,
  selectProfile,
  updateCompany,
} from '../features/api/slices/profile-slice';
import {
  fetchIndustries,
  selectIndustriesSectors,
} from '../features/api/slices/tags-slice';
import { useClientApi, useNewClientApi } from '../features/api/use-client-api';
import { resolveHeaderUserMenuLinks } from './header-user-menu-links';

const ClientPageHeader = () => {
  const { t } = useTranslations();
  const api = useClientApi();
  const newApi = useNewClientApi();
  const profile = useAppSelector(selectProfile);
  const { accessLevel } = usePremiumAccess();
  const company = useAppSelector(selectCompany);
  const admin = useAppSelector(selectCompanyAdmin);
  const analytics = useClientAnalytics();
  const dispatch = useAppDispatch();
  const industrySectors = useAppSelector(selectIndustriesSectors);
  const legalStructures = useAppSelector(selectLegalStructures);
  const { selectedLocale } = useLocale();

  useEffect(() => {
    dispatch(fetchIndustries({ api, locale: selectedLocale }));
    dispatch(fetchLegalStructures({ api: newApi, locale: selectedLocale }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLocale]);

  const links = useMemo(
    () => resolveHeaderUserMenuLinks(accessLevel, t),
    [accessLevel, t],
  );

  const updateCompanyInfo = async (data: FormData) => {
    await dispatch(updateCompany({ api, data }));
  };

  return (
    <>
      <AppHeader
        profile={profile}
        userMenuLinks={links}
        hideDesktopLogo
        actions={
          <MarketingControlledButton
            type="app-header"
            company={company}
            admin={admin}
            openMeetingModalClicked={analytics.openMeetingModalClicked}
            updateCompany={updateCompanyInfo}
            legalStructures={legalStructures}
            industrySectors={industrySectors}
          />
        }
      />
      {accessLevel !== 'custom' && <TourChecklistDropdown />}
    </>
  );
};

export default ClientPageHeader;
